/*----------------------
CURRENCY
 ----------------------*/
 currency = {
    init: function () {
      $(".disclosure__button").on("click", function () {
        $(".disclosure").toggleClass("open-currency");
      });

      $("body").on("click", function(e){
        if (!$(e.target).closest('.disclosure__button').length) {
            $(".disclosure").removeClass("open-currency");
        }
    })
    
    }
  };


  $(document).ready(function () {
    currency.init();
});
$(document).on('shopify:section:load', function (event) {
    currency.init();
});